export const plainTextFromHTML = (html: string): string => {
  if (html) {
    const doc = new DOMParser().parseFromString(html.slice(0, 300), "text/html")
    return doc.body.textContent || ""
  } else {
    return ""
  }
}
